<template>
    <div
        class="dropdown border-default bg-primary-white region-dropdown"
        :class="{
            'border-disabled': !isResults
        }"
        id="dropdown-container"
        ref="dropdownWrap"
    >
        <button
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="align-items-center w-100 border-0 d-flex h-100 outline-none text-nowrap bg-primary-white line-height-0 position-absolute top-0 left-0 bg-none"
            :class="{
                'dropdown-toggle': !selected
            }"
            :disabled="!isResults"
            ref="dropdown"
        >
            <GeoIcon></GeoIcon>
            <div class="subcaption text-primary-black content text-elipsis">
                <span :class="{ 'text-disabled': !isResults, 'subcaption-strong': selected }">
                    {{ selected ? selected.data.label : store.contents.placeHolders.regions }}
                </span>
            </div>

            <span class="justify-content-end flex-grow-1 arrow-up">
                <ArrowUp></ArrowUp>
            </span>
            <span class="justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>
            <!-- <i
				class="fas fa-times d-none d-lg-inline ml-2"
				v-if="selected"
				@click.stop="clear"
			></i>
			<i
				class="fas fa-times-circle d-inline d-lg-none ml-2"
				v-if="selected"
				@click="clear"
			></i> -->
        </button>
        <ul
            v-if="isResults"
            class="dropdown-menu shadow-4 tf-scroll-container--50vh w-100"
            @click.stop
            :class="{
                'd-none': !isResults
            }"
        >
            <template v-for="item in regions">
                <li
                    class="py-1 px-4 subp text-primary-black cursor-pointer subcaption text-primary-black"
                    :class="{
                        'bg-primary-blue text-primary-white': item.isSelected
                    }"
                    @click="toggle(item)"
                    :key="item.type + item.data.label"
                >
                    {{ item.data.label }}
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import GeoIcon from '@se/components/svg/common/geo/index.vue'

export default {
    name: 'Regions',
    components: {
        GeoIcon,
        ArrowUp,
        ArrowDown
    },
    props: {
        store: Object
    },
    data() {
        return {
            off: []
        }
    },
    computed: {
        regions() {
            return this.store.data.geoData.regions
                .reduce((list, region) => {
                    return this.store.data.available.regionsMap[region.id]
                        ? [
                              ...list,
                              {
                                  type: 'region',
                                  data: region,
                                  isSelected: this.store.data.selected.region === region.id
                              }
                          ]
                        : [...list]
                }, [])
                .sort((a, b) => (a.data.label > b.data.label ? 1 : -1))
        },
        selected() {
            if (this.store.data.selected.region) {
                const regionId = this.store.data.selected.region
                const region = this.store.data.geoData.regionsMap[regionId]
                if (!region) {
                    return null
                }
                return {
                    type: 'region',
                    data: region
                }
            }
            return null
        },
        isResults() {
            return !!this.regions.length
        }
    },
    methods: {
        toggle(item) {
            if (item.isSelected) {
                this.unselect(item)
            } else {
                this.select(item)
            }
        },
        select(item) {
            if (item.type === 'region') {
                this.store.libs.se.batch(() => {
                    this.store.libs.se.setFieldValue('region', item.data.id)
                    this.store.libs.se.setFieldValue('domaineSki', undefined)
                    this.store.libs.se.setFieldValue('parentStation', undefined)
                    this.store.libs.se.setFieldValue('station', undefined)
                })
            }
            $(this.$refs.dropdown).dropdown('hide')
        },
        unselect(item) {
            this.store.libs.se.batch(() => {
                this.store.libs.se.setFieldValue('region', undefined)
                this.store.libs.se.setFieldValue('domaineSki', undefined)
            })
        },
        clear() {
            this.unselect(this.selected)
            $(this.$refs.dropdown).dropdown('hide')
        },
        showDropdown() {
            $(this.$refs.dropdown).dropdown('show')
        }
    },
    beforeDestroy() {
        this.off.forEach((off) => off())
    },
    mounted() {
        const se = this.store.libs.se

        this.off.push(
            se.onAvailableFieldValues(
                'region',
                () => {
                    const regions = se.getAvailableFieldValues('region')
                    this.store.data.available.regions = regions
                    this.store.data.available.regionsMap = regions.reduce((map, value) => ((map[value] = true), map), {})
                },
                true
            )
        )

        this.off.push(
            se.onFieldValue(
                'region',
                () => {
                    const region = se.getFieldValue('region') || null
                    this.store.data.selected.region = region
                },
                true
            )
        )
    }
}
</script>

<style scoped>
.arrow-up {
    display: flex;
}

.arrow-down {
    display: none;
}

.region-dropdown.show .arrow-down {
    display: flex;
}

.region-dropdown.show .arrow-up {
    display: none;
}
</style>
